<template>
  <div class="aid" :data-testid="rootTestid" @click.stop>
    <span v-if="colorwayLabel" class="aid__item" :data-testid="tid('colorway-count')">{{
      colorwayLabel
    }}</span>
    <span
      v-for="fact in facts"
      :key="fact.key"
      class="aid__item"
      :data-testid="tid(`fact-${fact.key}`)"
      >{{ fact.text }}</span
    >
    <span v-if="designCode" class="aid__item" :data-testid="tid('design-code')"
      >Back-office ID {{ designCode }}</span
    >
    <span
      v-if="decoratorCode"
      class="aid__item"
      :data-testid="tid('decorator-code')"
      >Decorator ID {{ decoratorCode }}</span
    >
    <span class="aid__item" :data-testid="tid('internal-id')"
      >ID {{ artworkId }}</span
    >
  </div>
</template>

<script>
/**
 * Small muted identifiers line for an artwork: colorway count, the facts
 * (stitches, colors, added by/when, digitizer; see artworkFacts.js), Back-office
 * ID (design_code), Decorator ID (decorator_artwork_code) and the internal
 * ID. The two codes are different identifiers and never stand in for each
 * other: an absent one renders nothing. Text is selectable (copy-friendly),
 * and a click inside the line does not bubble to a clickable parent row.
 *
 * `scope` picks the data-testid family: "list" -> dl-<kind>-<id>;
 * "detail" -> artwork-detail-<kind>.
 */
export default {
  name: "ArtworkIdentifiers",
  props: {
    artworkId: { type: [Number, String], required: true },
    designCode: { type: String, default: null },
    decoratorCode: { type: String, default: null },
    colorwayCount: { type: Number, default: 0 },
    // [{key, text}] from artworkFacts.js: stitches, colors, added, digitizer.
    facts: { type: Array, default: () => [] },
    scope: {
      type: String,
      default: "list",
      validator: (v) => ["list", "detail"].includes(v),
    },
  },
  computed: {
    colorwayLabel() {
      const n = this.colorwayCount;
      if (!n || n < 1) return "";
      return `${n} ${n === 1 ? "colorway" : "colorways"}`;
    },
    rootTestid() {
      return this.scope === "detail"
        ? "artwork-detail-identifiers"
        : `dl-identifiers-${this.artworkId}`;
    },
  },
  methods: {
    tid(kind) {
      return this.scope === "detail"
        ? `artwork-detail-${kind}`
        : `dl-${kind}-${this.artworkId}`;
    },
  },
};
</script>

<style scoped>
.aid {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  font-size: 11px;
  line-height: 1.4;
  color: #6b7280;
}
.aid__item {
  user-select: text;
  cursor: text;
}
</style>
